/*
    路由规则
*/
// 内嵌页主组件（嵌套路由的最高层）
import Index from '@/components/common/Index'
// portal部分


// 用户中心部分
export default [{
        path: '/',
        name: 'Index',
        component: () => import('@/components/common/Index'), // 此组件为模板页
        children: [ // 子路由，成功匹配，则填充到<router-view>
            //首页
            {
                path: "/",
                name: "Home",
                component: () => import('@/views/protal/Home'),
            },
            //InfoList
            {
                path: "/InfoList",
                name: "InfoList",
                component: () => import('@/views/protal/InfoList'),
            },
            //重点项目
            {
                path: "/ProjectList",
                name: "ProjectList",
                component: () => import('@/views/protal/ProjectList'),
            },
        ]
    },
    /*这些是测试用的 */
    // {
    //     path: '/test',
    //     name: 'test',
    //     component: () => import('@/components/common/test')
    // },
    // {
    //     path: '/Sample/Index',
    //     name: 'SampleIndex',
    //     component: () => import('@/views/sample/Index')
    // },
    // {
    //     path: '/Sample/Upload',
    //     name: 'SampleUpload',
    //     component: () => import('@/views/sample/Upload')
    // },
    // {
    //     // 匹配不到，跳转404页
    //     path: '*',
    //     name: 'Page404',
    //     component: () => import('@/components/error/404'),
    // }
]